<template>
  <!-- 特约 -->
  <div class="specialAgreement">
    <div v-if="JQList !== []" class="li-content">
      <div class="border-style">
        <mt-cell class="title-weight" title="交强险特约" />
      </div>
      <div v-for="(item, index) in JQListMust" :key="index" class="choose-area">
        <div>
          <span>{{ item.clauseName }}</span>
          <span class="must-choose">必选</span>
        </div>
        <p>{{ item.clauseContent }}</p>
      </div>
      <div v-for="(item, index) in JQList" :key="'jq'+index" class="choose-area" @click="select(item, index)">
        <div>
          <div>
            <div>
              <van-icon :name="item.verdict ? 'checked' : 'circle'" :color="item.verdict ? '#f29600' : ''" />
              <span>{{ item.clauseName }}</span>
            </div>
            <img v-if="item.modifyFlag === '1'" :src="img" alt="" @click.stop="JQShowEdit(index)">
          </div>
          <p>{{ item.clauseContent }}</p>
        </div>
      </div>
    </div>
    <div v-if="SYList !== []" class="li-content" style="padding-bottom: 0.8rem;">
      <div class="border-style">
        <mt-cell class="title-weight" title="商业险特约" />
      </div>
      <div v-for="(item, index) in SYListMust" :key="index" class="choose-area">
        <div>
          <span>{{ item.clauseName }}</span>
          <span class="must-choose">必选</span>
        </div>
        <p>{{ item.clauseContent }}</p>
      </div>
      <div v-for="(item, index) in SYList" :key="'sy'+index" class="choose-area" @click="select(item, index)">
        <div>
          <div>
            <div>
              <van-icon :name="item.verdict ? 'checked' : 'circle'" :color="item.verdict ? '#f29600' : ''" />
              <span>{{ item.clauseName }}</span>
            </div>
            <img v-if="item.modifyFlag === '1'" :src="img" alt="" @click.stop="SYShowEdit(index)">
          </div>
          <p>{{ item.clauseContent }}</p>
        </div>
      </div>
    </div>
    <div v-show="goNextBtn" class="next-step">
      <button @click="goBack">
        下一步
      </button>
    </div>
    <van-popup v-model="showEdit" style="border-radius: 7px;">
      <div class="edit-contain">
        <div class="text-area">
          <textarea v-model="waitEditContent" />
        </div>
        <div class="btn-area">
          <div style="color:rgba(153,153,153,1)" @click="showEdit=false">
            取消
          </div>
          <div style="color:rgba(94,37,137,1)" @click="confirmEdit">
            确定
          </div>
        </div>
      </div>
    </van-popup>
    <Loading :switchs="switchs" />
  </div>
</template>
<script>
import api from '@/api/api.js'
import { Toast } from 'vant'
import Loading from '@/components/Loadings/Loading'

export default {
  components: {
    'Loading': Loading
  },
  data() {
    return {
      switchs: false,
      img: api.imgAllUrl + '/sales270709.png',
      showEdit: false,
      JQclauseCode: [], // 交强已选
      SYclauseCode: [], // 商业已选
      JQList: [],
      JQListMust: [],
      SYList: [],
      SYListMust: [],
      waitEditContent: '',
      JQKey: '', // 当前选中修改
      SYKey: '',
      state: '',
      goNextBtn: true,
      originHeight: ''
    }
  },
  mounted() {
    // if(this.$store.state.tab === '3'){
    //   this.$store.commit('setProvince',this.$store.state.orderIn.vehicleInfo.provinceCode)
    // }
  },
  activated() {
    this.originHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight || 0
    window.addEventListener('resize', this.resizeFn)
    this.JQList = []
    this.JQListMust = []
    this.SYList = []
    this.SYListMust = []
    this.JQclauseCode = []
    this.SYclauseCode = []
    this.$store.commit('setShow', false)
    this.getDetail()
  },
  deactivated() {
    window.removeEventListener('resize', this.resizeFn)
    this.goNextBtn = true
  },
  destroyed() {
    Toast.clear()
    window.removeEventListener('resize', this.resizeFn)
    this.goNextBtn = true
  },
  methods: {
    resizeFn() {
      const resizeHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight || 0
      if (this.originHeight - 0 > resizeHeight - 0) {
        this.goNextBtn = false
      } else {
        this.goNextBtn = true
      }
    },
    select(item, index) {
      item.verdict = !item.verdict
    },
    goBack() {
      const arr = []
      if (this.JQList !== []) {
        this.JQList.forEach(item => {
          if (item.verdict) {
            const obj = {
              clauseCode: item.clauseCode,
              clauseName: item.clauseName,
              clauses: item.clauseContent,
              riskCode: item.riskCode
            }
            arr.push(obj)
          }
        })
      }
      if (this.SYListMust !== []) {
        this.SYListMust.forEach(item => {
          const obj = {
            clauseCode: item.clauseCode,
            clauseName: item.clauseName,
            clauses: item.clauseContent,
            riskCode: item.riskCode
          }
          arr.push(obj)
        })
      }
      if (this.SYList !== []) {
        this.SYList.forEach(item => {
          if (item.verdict) {
            const obj = {
              clauseCode: item.clauseCode,
              clauseName: item.clauseName,
              clauses: item.clauseContent,
              riskCode: item.riskCode
            }
            arr.push(obj)
          }
        })
      }
      if (this.JQListMust !== []) {
        this.JQListMust.forEach(item => {
          const obj = {
            clauseCode: item.clauseCode,
            clauseName: item.clauseName,
            clauses: item.clauseContent,
            riskCode: item.riskCode
          }
          arr.push(obj)
        })
      }
      const data = {
        orderId: this.$store.state.orderId,
        engageList: arr,
        terminalId: localStorage.getItem('setTerminalId'),
        orderOrigin: localStorage.getItem('setChannelCode'),
        channelCode: localStorage.getItem('setChannelCode'),
        vehicleInfo: this.$store.state.vehicleInfos
      }
      this.switchs = true
      this.$http.post(api.save, data)
        .then(res => {
          if (res.data.rtnCode === '0000') {
            this.$store.commit('setEngageList', arr)
            this.$router.replace({ name: 'Supplementary' })
          }
          this.switchs = false
        })
        .catch(error => {
          console.log(error)
          this.switchs = false
        })
    },
    queryClauseDatas(value) {
      this.$http.post(api.queryClauseData, value)
        .then(res => {
          Toast.clear()
          const userInfo = JSON.parse(localStorage.getItem('setPersonUserInfo'))
          if (res.data.rtnCode === '0000') {
            const returnData = res.data.resultObj
            returnData.forEach(item => {
              this.$store.commit('setEngageLists', true)
              if (userInfo) {
                if ((item.optType === '3' && item.clauseCode === 'T2007' && (userInfo.salesmanInfoDto.comCode.startsWith('212') || userInfo.salesmanInfoDto.comCode.startsWith('261'))) || (item.optType === '3' && item.clauseCode === 'T2013' && userInfo.salesmanInfoDto.comCode.startsWith('261'))) {
                  item.optType = '2'
                }
              }
              if (item.clauseType === '2' && item.optType === '3') {
                item.verdict = true
                this.JQList.push(item)
              } else if (item.clauseType === '1' && item.optType === '3') {
                item.verdict = true
                this.SYList.push(item)
              } else if (item.clauseType === '2' && item.optType === '1') {
                item.verdict = false
                if (this.$store.state.engageList && this.$store.state.engageList !== '') {
                  this.$store.state.engageList.forEach(EL => {
                    if (EL.clauseCode === item.clauseCode) {
                      item.verdict = true
                    }
                  })
                }
                this.JQList.push(item)
              } else if (item.clauseType === '1' && item.optType === '1') {
                item.verdict = false
                if (this.$store.state.engageList && this.$store.state.engageList !== '') {
                  this.$store.state.engageList.forEach(engEl => {
                    if (engEl.clauseCode === item.clauseCode) {
                      item.verdict = true
                    }
                  })
                }
                this.SYList.push(item)
              } else if (item.clauseType === '2' && item.optType === '2') {
                this.JQListMust.push(item)
              } else if (item.clauseType === '1' && item.optType === '2') {
                this.SYListMust.push(item)
              }
            })
          } else {
            this.$toast(res.data.rtnMsg)
          }
          this.switchs = false
        })
        .catch(error => {
          Toast.clear()
          console.log(error)
          this.switchs = false
        })
    },
    getDetail() {
      this.switchs = true
      let riskcode = ''
      if (this.$store.state.calculateFlag === '2') {
        riskcode = '0590'
      } else if (this.$store.state.calculateFlag === '1') {
        riskcode = localStorage.getItem('whetherFeeChangeArea') === '1' ? '050A' : '0501'
      } else {
        riskcode = localStorage.getItem('whetherFeeChangeArea') === '1' ? '050A,0590' : '0501,0590'
      }
      const param = {
        orderId: this.$store.state.orderId,
        provinceCode: this.$store.state.proposalAreaCode,
        riskCode: riskcode// 险种代码（0590-交强/0501-商业）
      }
      // let URL = window.location.href
      // if (URL.indexOf('terminalId=APP') !== -1) {
      //   this.$http.get(api.getUpProvinceCom)
      //     .then((res)=>{
      //       param.provinceCode = res.data[0].newCodeCode
      //       this.queryClauseDatas(param)
      //     })
      //     .catch(error => {
      //       this.queryClauseDatas(param)
      //       console.log(error)
      //     })
      // } else {
      //   this.queryClauseDatas(param)
      // }
      this.queryClauseDatas(param)
    },
    JQShowEdit(index) {
      this.state = 'JQ'
      this.JQKey = index
      this.showEdit = true
      this.waitEditContent = this.JQList[index].clauseContent
    },
    SYShowEdit(index) {
      this.state = 'SY'
      this.SYKey = index
      this.showEdit = true
      this.waitEditContent = this.SYList[index].clauseContent
    },
    confirmEdit() {
      if (this.state === 'SY') {
        this.SYList[this.SYKey].clauseContent = this.waitEditContent
      } else if (this.state === 'JQ') {
        this.JQList[this.JQKey].clauseContent = this.waitEditContent
      }
      this.showEdit = false
    }
  }
}
</script>
<style lang="scss" scoped>
@import "./specialAgreement.scss";
</style>



// WEBPACK FOOTER //
// src/pages/car/clause/index.vue